import styled from 'styled-components';

export const CompanyPurchasePage = styled.main`
  /* border: 3px solid red; */
  min-height: 100vh;
  display: flex;
  @media screen and (max-width: 768px) {
    /* border: 3px solid blue; */
    width: 100%;
    overflow-y: hidden;
    flex-direction: column;
    height: 100%;
  }
`;

export const CompanyPurchaseLeft = styled.section`
  /* border: 3px solid orange; */
  width: 70%;
  padding: ${({ theme }) => theme.spacing.m};
  .selectCourse {
    /* border: 2px solid red; */
    margin-block: ${({ theme }) => theme.spacing.s};
  }

  table {
    /* border: 1px solid green; */
    /* border-collapse: collapse; */
    tr:nth-child(odd) {
      background-color: ${({ theme }) => theme.colors.offWhite};
    }
    tr:nth-child(even) {
      background-color: ${({ theme }) => theme.colors.white};
    }

    th {
      background-color: ${({ theme }) => theme.colors.grey};
      color: ${({ theme }) => theme.colors.grey5};
      padding: ${({ theme }) => theme.spacing.xs};
      text-align: left;
      border: 1px solid ${({ theme }) => theme.colors.grey};
    }

    td {
      padding: ${({ theme }) => theme.spacing.xs};
      text-align: left;
      border: 1px solid ${({ theme }) => theme.colors.grey};
    }
  }
  @media screen and (max-width: 1024px) {
    width: 60%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    .selectCourse {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .selectCourse select {
      width: 50%;
    }
  }
`;

export const CompanyPurchaseRight = styled.aside`
  width: 30%;
  padding: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  background-color: ${({ theme }) => theme.colors.offWhite};
  min-height: 100vh;
  overflow: visible;
  /* border: 5px solid orange; */
  h4 {
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid ${({ theme }) => theme.colors.grey};
    margin-bottom: ${({ theme }) => theme.spacing.xs};
  }
  h5 {
    font-size: ${({ theme }) => theme.spacing.m};
    font-weight: 800;
    background-color: ${({ theme }) => theme.colors.grey};
    padding: ${({ theme }) => theme.spacing.xs};
    border-radius: ${({ theme }) => theme.borderRadius};
  }
  aside {
    border-radius: ${({ theme }) => theme.borderRadius};
    padding: ${({ theme }) => theme.spacing.s};
    box-shadow: inset 0px 0px 8px 0px ${({ theme }) => theme.colors.grey1};
    background-color: ${({ theme }) => theme.colors.white};
  }
  .cart {
    /* background-color: ${({ theme }) => theme.colors.offWhite}; */
  }
  .total {
    margin-top: ${({ theme }) => theme.spacing.m};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xs};
    justify-content: space-between;
    align-items: end;
  }
  .total p {
    /* border: 1px solid red; */
    width: 50%;
    display: flex;
    font-weight: bold;
    justify-content: space-between;
  }
  .italic {
    font-style: italic;
  }
  .discount {
    input {
      width: 60%;
      margin-top: ${({ theme }) => theme.spacing.xxxs};
    }
  }
  .totalPrice {
    border-top: 1px solid ${({ theme }) => theme.colors.grey};
    padding-top: ${({ theme }) => theme.spacing.xs};
  }
  .billing h4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .billing button {
    margin: 0;
    padding: 0;
    text-align: right;
  }
  .ppbuttons {
    /* border: 5px solid red; */
    display: flex;
    flex-direction: column;
  }
  @media screen and (max-width: 1024px) {
    width: 40%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    .paypal {
      /* border: 2px solid orange; */
      margin: 0 auto;
    }
  }
`;

export const CourseInformation = styled.aside`
  /* border: 2px  solid red; */
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};
  margin-block: ${({ theme }) => theme.spacing.s};
  background-color: ${({ theme }) => theme.colors.grey};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.m};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  h3 {
    text-transform: uppercase;
  }
  p {
    font-weight: 600;
    font-size: 0.9rem;
  }
  span {
    font-weight: 400;
    font-size: 0.9rem;
  }
  .p2 {
    border-top: 1px solid ${({ theme }) => theme.colors.grey2};
    padding-top: ${({ theme }) => theme.spacing.xxs};
    color: ${({ theme }) => theme.colors.grey3};
  }
`;
